/// <reference types="./dirtyUpdateEntity.d.ts" />
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryRun } from '../QueryFunctions.js';
export async function managementDirtyUpdateEntity(database, context, reference, valid, validPublished) {
    const invalid = (valid === false ? 1 : 0) | (validPublished === false ? 2 : 0);
    const { query, sql } = createSqliteSqlQuery();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    sql `UPDATE entities SET invalid = ${invalid}, dirty = 0 WHERE id = ${reference.entityInternalId}`;
    const result = await queryRun(database, context, query);
    return result.isOk() ? ok(undefined) : result;
}
//# sourceMappingURL=dirtyUpdateEntity.js.map